import { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { API_BASE as API } from "../api/base";

export default function PublicReviewRedirect() {
  const { promptId } = useParams();
  const location = useLocation();

  useEffect(() => {
    if (!promptId) return;
    const isSurvey = location.pathname.includes("/r/public-review/survey/");
    const routeSuffix = isSurvey ? "/survey" : "";
    window.location.href = `${API}/r/public-review${routeSuffix}/${promptId}`;
  }, [location.pathname, promptId]);

  return (
    <div className="min-h-screen bg-slate-100 flex items-center justify-center px-4">
      <div className="rounded-2xl border border-slate-200 bg-white px-6 py-4 text-sm text-slate-600 shadow">
        Redirecting to the review page...
      </div>
    </div>
  );
}
